import React from 'react';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = {
    instagram: 'https://www.instagram.com/rkrotoarc/',
    facebook: 'https://www.facebook.com/share/14YbW3nn3gR/'
  };

  return (
    <footer className="bg-zinc-900 border-t border-zinc-800">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_rk-rotoarc-preview/artifacts/qs3pkdc4_IMG_4982.jpeg" 
              alt="RK ROTOARC" 
              className="h-12 w-auto mb-4 brightness-0 invert"
            />
            <p className="text-zinc-400 text-sm mb-4">
              Powering the backbone of welding industries with premium equipment built for performance and durability.
            </p>
            <p className="text-zinc-500 text-xs">
              Trademark Registered: {contactInfo.establishedYear}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4 text-lg">Quick Links</h3>
            <ul className="space-y-2 text-zinc-400 text-sm">
              <li>
                <a href="#home" className="hover:text-yellow-400 transition-colors">Home</a>
              </li>
              <li>
                <a href="#about" className="hover:text-yellow-400 transition-colors">About Us</a>
              </li>
              <li>
                <a href="#products" className="hover:text-yellow-400 transition-colors">Products</a>
              </li>
              <li>
                <a href="#industries" className="hover:text-yellow-400 transition-colors">Industries We Serve</a>
              </li>
              <li>
                <a href="#dealer" className="hover:text-yellow-400 transition-colors">Become a Dealer</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-yellow-400 transition-colors">Contact Us</a>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white font-bold mb-4 text-lg">Products</h3>
            <ul className="space-y-2 text-zinc-400 text-sm">
              <li>Electrode Holders & Clamps</li>
              <li>ISI Cutting Equipment</li>
              <li>Non-ISI Cutting Equipment</li>
              <li>LPG Regulators</li>
              <li>Personal Protective Equipment</li>
              <li>Drying Ovens</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold mb-4 text-lg">Contact Us</h3>
            <ul className="space-y-3 text-zinc-400 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" />
                <span>{contactInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-yellow-400 flex-shrink-0" />
                <a href={`tel:${contactInfo.phone}`} className="hover:text-yellow-400 transition-colors">
                  +91 {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-yellow-400 flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-yellow-400 transition-colors">
                  {contactInfo.email}
                </a>
              </li>
            </ul>

            {/* Social Media */}
            <div className="mt-6">
              <h4 className="text-white font-semibold mb-3 text-sm">Follow Us</h4>
              <div className="flex gap-3">
                <a 
                  href={socialLinks.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-zinc-800 flex items-center justify-center text-zinc-400 hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-600 hover:text-white transition-all duration-300"
                  aria-label="Instagram"
                >
                  <Instagram className="w-4 h-4" />
                </a>
                <a 
                  href={socialLinks.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-zinc-800 flex items-center justify-center text-zinc-400 hover:bg-blue-600 hover:text-white transition-all duration-300"
                  aria-label="Facebook"
                >
                  <Facebook className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-zinc-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-zinc-500 text-sm">
            <p>© {currentYear} RK ROTOARC. All rights reserved.</p>
            <p className="text-zinc-600 text-xs">
              Built for Professionals | World-Class Welding Performance
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;